module.exports = __webpack_public_path__ + "media/images/menu/reflection_nebulae-cc465959bdecd2f61a7ed5963160265b.jpg";